import { MutableRefObject, useEffect, useRef } from 'react'

import { addClickListener, PointerType } from './clickListener'

export const useClickListener = (
  elem: MutableRefObject<HTMLElement | null>,
  callback: (e: MouseEvent, pointerType: PointerType) => void
) => {
  const removeListener = useRef(() => {})

  useEffect(() => {
    if (!elem.current) return
    removeListener.current = addClickListener(elem.current, callback)
    return () => removeListener.current()
  }, [callback, elem])

  return removeListener.current
}
